<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="error">
    <LoadingIndicator />

    <NuxtLayout :name="layoutName">
      <ErrorPage :error="props.error" />
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
import type { LayoutKey, NuxtError } from '#app'

const props = defineProps<{
  error?: NuxtError
}>()

const route = useRoute()
const isAccountPage = computed(() => {
  return route.fullPath.indexOf('/account') !== -1
})

const layoutName = computed<LayoutKey>(() => {
  if (!useUserSession().loggedIn.value) {
    return 'empty'
  } else if (isAccountPage.value) {
    return 'account'
  }
  return 'error'
})
</script>
